import { defineStore } from 'pinia';

export const useRegisterStore = defineStore('register', {
    state: () => ({
      cardNumber: null,
    }),
    getters: {
      getCardNumber: (state) => state.cardNumber,
    },
    actions: {
      setCardNumber(cardNumber) {
        this.cardNumber = cardNumber;
      },
      clearCardNumber() {
        this.cardNumber = null;
      }
    },
    persist: {
      storage: localStorage,
    },
});
